// @ts-ignore-line
import { getInstance } from "@/auth/auth0";
import { AxiosInstance, AxiosRequestConfig } from "axios";

export default class JwtService {
    constructor(public readonly axiosIns: AxiosInstance) {
        this.axiosIns.interceptors.request.use(
            async (config: AxiosRequestConfig) => {
                if (getInstance().isAuthenticated) {
                    const { auth0Client } = getInstance();
                    try {
                        const accessToken = (await auth0Client.getTokenSilently({ detailedResponse: true }))?.id_token;
                        config.headers = {
                            ...config.headers,
                            Authorization: `Bearer ${accessToken}`,
                        };
                    } catch (error: unknown) {
                        if (error instanceof Error && error.message === "login_expired") {
                            if (getInstance().isAuthenticated) {
                                getInstance().auth0Client.logout({ returnTo: window.location.origin });
                                return;
                            }
                        }

                        throw error;
                    }
                }

                return config;
            },
            (error) => {
                if (error instanceof Error && error.message === "login_expired") {
                    if (getInstance().isAuthenticated) {
                        getInstance().auth0Client.logout({ returnTo: window.location.origin });
                        return;
                    }
                }
                return Promise.reject(error);
            }
        );
    }
}
